// src/lib/revenu-fbz-mois.js — LE « REVENU FULLBNBZEN DU MOIS », UNE SEULE FOIS.
//
// Le chiffre-roi de l'écran Argent › Facturation (src/App.jsx) : la somme des
// commissions des mandats (tous propriétaires hors p6) et du bénéfice de la
// sous-location (CA des chambres − loyer − charges du parent). Il vivait
// inline dans l'écran ; l'opérateur doit pouvoir le rendre (« combien j'ai
// gagné en juillet ») — et sur de l'argent, deux calculs « à peu près
// pareils » divergent au premier correctif appliqué d'un seul côté, les deux
// restant plausibles. D'où une fonction, deux consommateurs.
//
// ⚠️ PUR, sans dépendance. Miroir CJS : lib/revenu-fbz-mois.js (ADR-021),
// parité testée sur les sorties.
//
// ⚠️ UN TAUX MANQUANT PRODUIT NaN, ET NaN SE PROPAGE. C'est voulu (paquet
// argent 2026-09-03) : un revenu incalculable s'affiche « — » avec son
// explication, jamais un 0,00 € menteur. `calculable` le dit en clair pour
// ceux qui ne lisent pas NaN.

/**
 * @param {{commissions: number|number[], benefSousLoc: number}} p
 *   commissions — la commission FBZ de chaque logement en mandat (ou déjà
 *   sommée) ; NaN si un taux manque.
 *   benefSousLoc — le bénéfice de la sous-location (peut être 0 ou négatif).
 * @returns {{commissions:number, sousLoc:number, total:number, calculable:boolean}}
 */
export function revenuFbzDuMois({ commissions, benefSousLoc } = {}) {
  const c = Array.isArray(commissions)
    ? commissions.reduce((s, x) => s + Number(x), 0)
    : Number(commissions);
  const b = Number(benefSousLoc);
  const total = c + b;
  return {
    commissions: c,
    sousLoc: b,
    total,
    calculable: Number.isFinite(total),
  };
}
